export const en = {
   hero: {
      title: 'About AKAS',
      description:
         "AKAS is Cambodia's leading provider of cloud-based business ERP solutions, helping businesses of all sizes streamline operations, increase efficiency, and drive growth through innovative software.",
   },
   mission: {
      title: 'Our Mission',
      description:
         'To empower businesses with accessible, innovative cloud solutions that drive efficiency, growth, and digital transformation.',
   },
   story: {
      title: 'Our Story',
      paragraphs: [
         'Founded in Phnom Penh in 2024, AKAS was created to make powerful business software accessible to organizations of all sizes—without the high cost of international platforms or the limitations of spreadsheets. Built as a modular, cloud-based business management suite, AKAS combines practical technology, local expertise, and hands-on implementation to help businesses operate smarter and scale with confidence.',

         'What began with HRMS has evolved into an integrated platform connecting the entire business lifecycle: from recruitment to payroll, lead management to customer receipts, purchasing to accounts payable, and operational transactions to the general ledger. With multilingual interfaces, visual workflow automation, and support for local payroll and payment requirements, AKAS brings business processes together in one connected system—designed around the realities of doing business in Cambodia and built to grow with each organization.',

         '**With AKAS, businesses gain more than software—they gain a foundation for growth.** By connecting people, processes, and financial data in one platform, AKAS helps organizations reduce manual work, improve visibility, strengthen control, and make better decisions. Our mission is to give every growing business the tools, guidance, and confidence to operate like a well-connected enterprise—without enterprise-level complexity or cost.',
      ],
   },
   valuesTitle: 'Our Values',
   values: [
      {
         title: 'Innovation',
         description:
            'We continuously evolve our solutions with the latest technologies to meet the changing needs of businesses.',
      },
      {
         title: 'Reliability',
         description:
            'Our secure, stable cloud infrastructure ensures your business data is always accessible and protected.',
      },
      {
         title: 'Close support',
         description:
            'Payroll, payments, languages, and day-to-day support are part of the product — not a distant add-on pack.',
      },
      {
         title: 'Client Success',
         description:
            'We measure our success by the success of our clients, providing ongoing support and training to maximize ROI.',
      },
   ],
   team: {
      title: 'Our Team',
      intro: 'Led by experienced software developers and business consultants, our team combines technical expertise with a practical understanding of how businesses actually operate.',
      members: [
         {
            name: 'CHEAM Savun',
            position: 'CTO (Consultant)',
            bio: 'Over 20 years working in IT and Software development',
         },
      ],
   },
   cta: {
      title: 'Ready to transform your business?',
      description:
         'Contact us today to learn how AKAS solutions can help your organization thrive.',
      button: 'Contact Us',
   },
};

export type Copy = typeof en;

export const km: Copy = {
   hero: {
      title: 'អំពី AKAS',
      description:
         'AKAS គឺជាអ្នកផ្តល់ដំណោះស្រាយ Cloud ERP ឈានមុខគេនៅកម្ពុជា ជួយអាជីវកម្មគ្រប់ទំហំសម្រួលប្រតិបត្តិការ បង្កើនប្រសិទ្ធភាព និងជំរុញកំណើនតាមរយៈកម្មវិធីច្នៃប្រឌិត។',
   },
   mission: {
      title: 'បេសកកម្មរបស់យើង',
      description:
         'ជួយឱ្យអាជីវកម្មមានសមត្ថភាពតាមរយៈដំណោះស្រាយ Cloud ដែលងាយស្រួលប្រើ និងច្នៃប្រឌិត ដើម្បីជំរុញប្រសិទ្ធភាព ការរីកចម្រើន និងការផ្លាស់ប្តូរទៅជាឌីជីថល។',
   },
   story: {
      title: 'រឿងរ៉ាវរបស់យើង',
      paragraphs: [
         'AKAS ត្រូវបានបង្កើតឡើងនៅរាជធានីភ្នំពេញក្នុងឆ្នាំ ២០២៤ ដោយមានគោលបំណងធ្វើឱ្យកម្មវិធីគ្រប់គ្រងអាជីវកម្មដ៏មានសមត្ថភាព ក្លាយជាជម្រើសដែលអាចប្រើប្រាស់បានសម្រាប់អង្គការគ្រប់ទំហំ ដោយមិនចាំបាច់ចំណាយខ្ពស់លើកម្មវិធីអន្តរជាតិ ឬពឹងផ្អែកលើសៀវភៅបញ្ជីដែលមានកម្រិត។ AKAS គឺជាប្រព័ន្ធគ្រប់គ្រងអាជីវកម្មលើ Cloud ដែលមានម៉ូឌុលអាចបត់បែនតាមតម្រូវការ ដោយរួមបញ្ចូលបច្ចេកវិទ្យាជាក់ស្តែង ជំនាញក្នុងស្រុក និងការគាំទ្រដោយផ្ទាល់ ដើម្បីជួយឱ្យអាជីវកម្មដំណើរការកាន់តែមានប្រសិទ្ធភាព និងរីកចម្រើនប្រកបដោយទំនុកចិត្ត។',
         'អ្វីដែលបានចាប់ផ្តើមពីប្រព័ន្ធគ្រប់គ្រងធនធានមនុស្ស (HRMS) បានវិវត្តទៅជាវេទិកាដែលរួមបញ្ចូលដំណើរការអាជីវកម្មទាំងមូល ចាប់ពីការជ្រើសរើសបុគ្គលិករហូតដល់ការបើកប្រាក់ខែ ការគ្រប់គ្រងឱកាសលក់រហូតដល់ការទទួលប្រាក់ពីអតិថិជន ការបញ្ជាទិញទំនិញរហូតដល់ការគ្រប់គ្រងបំណុលត្រូវបង់ទៅអ្នកផ្គត់ផ្គង់ ព្រមទាំងការភ្ជាប់ប្រតិបត្តិការពីម៉ូឌុលនានាទៅក្នុងសៀវភៅគណនីទូទៅ (General Ledger)។',
         'ជាមួយនឹងចំណុចប្រទាក់ពហុភាសា ប្រព័ន្ធរៀបចំលំហូរការងារដោយមើលឃើញ (Visual Workflow Automation) និងការគាំទ្រតម្រូវការបើកប្រាក់ខែ និងការទូទាត់ក្នុងស្រុក AKAS បង្រួបបង្រួមដំណើរការអាជីវកម្មទាំងអស់នៅក្នុងប្រព័ន្ធតែមួយដែលតភ្ជាប់គ្នា។ ប្រព័ន្ធនេះត្រូវបានរចនាឡើងដោយយកចិត្តទុកដាក់លើតម្រូវការជាក់ស្តែងនៃការធ្វើអាជីវកម្មនៅកម្ពុជា និងអាចពង្រីកសមត្ថភាពទៅតាមការរីកចម្រើនរបស់ស្ថាប័ននីមួយៗ។',
         '**ជាមួយ AKAS អាជីវកម្មទទួលបានច្រើនជាងកម្មវិធីគ្រប់គ្រង—អាជីវកម្មទទួលបានមូលដ្ឋានគ្រឹះដ៏រឹងមាំសម្រាប់ការរីកចម្រើន។** តាមរយៈការតភ្ជាប់បុគ្គលិក ដំណើរការការងារ និងទិន្នន័យហិរញ្ញវត្ថុទៅក្នុងប្រព័ន្ធតែមួយ AKAS ជួយកាត់បន្ថយការងារដោយដៃ បង្កើនភាពច្បាស់លាស់នៃព័ត៌មាន ពង្រឹងការគ្រប់គ្រង និងគាំទ្រការសម្រេចចិត្តឱ្យកាន់តែមានប្រសិទ្ធភាព។ បេសកកម្មរបស់យើង គឺផ្តល់ឱ្យអាជីវកម្មដែលកំពុងរីកចម្រើនគ្រប់រូបនូវឧបករណ៍ ជំនួយណែនាំ និងទំនុកចិត្ត ដើម្បីដំណើរការអាជីវកម្មប្រកបដោយប្រសិទ្ធភាពដូចសហគ្រាសធំៗ ដោយមិនចាំបាច់ប្រឈមនឹងភាពស្មុគស្មាញ ឬចំណាយខ្ពស់ដូចកម្មវិធីកម្រិតសហគ្រាសនោះទេ។',
      ],
   },
   valuesTitle: 'តម្លៃរបស់យើង',
   values: [
      {
         title: 'ការច្នៃប្រឌិត',
         description:
            'យើងបន្តអភិវឌ្ឍ និងធ្វើបច្ចុប្បន្នភាពដំណោះស្រាយរបស់យើង ដោយប្រើប្រាស់បច្ចេកវិទ្យាទំនើប ដើម្បីឆ្លើយតបនឹងតម្រូវការអាជីវកម្មដែលកំពុងវិវត្ត និងគាំទ្រការរីកចម្រើនប្រកបដោយចីរភាព។',
      },
      {
         title: 'ភាពអាចទុកចិត្តបាន',
         description:
            'ហេដ្ឋារចនាសម្ព័ន្ធ Cloud ដែលសុវត្ថិភាព និងស្ថិរភាពរបស់យើងធានាថា ទិន្នន័យអាជីវកម្មរបស់អ្នកតែងតែអាចចូលប្រើបាន និងត្រូវបានការពារជានិច្ច។',
      },
      {
         title: 'ជំនួយជិតស្និទ្ធ',
         description:
            'ការគណនាប្រាក់ខែ, ការទូទាត់, ភាសា និងជំនួយប្រចាំថ្ងៃ គឺជាផ្នែកមួយនៃផលិតផល — មិនមែនជាកញ្ចប់បន្ថែមទេ។',
      },
      {
         title: 'ជោគជ័យរបស់អតិថិជន',
         description:
            'យើងវាស់ភាពជោគជ័យរបស់យើងតាមភាពជោគជ័យរបស់អតិថិជន ដោយផ្តល់ជំនួយ និងការបណ្តុះបណ្តាលជាបន្តបន្ទាប់ ដើម្បីឱ្យការវិនិយោគទទួលបានផលច្រើនបំផុត។',
      },
   ],
   team: {
      title: 'ក្រុមការងាររបស់យើង',
      intro: 'ដឹកនាំដោយអ្នកអភិវឌ្ឍន៍កម្មវិធីដែលមានបទពិសោធន៍ និងអ្នកប្រឹក្សាអាជីវកម្ម ក្រុមការងាររបស់យើងរួមបញ្ចូលជំនាញបច្ចេកទេសជាមួយការយល់ដឹងជាក់ស្តែងអំពីរបៀបដែលអាជីវកម្មដំណើរការពិតប្រាកដ។',
      members: [
         {
            name: 'CHEAM Savun',
            position: 'CTO (Consultant)',
            bio: 'មានបទពិសោធន៍លើសពី ២០ ឆ្នាំក្នុងវិស័យព័ត៌មានវិទ្យា និងការអភិវឌ្ឍន៍កម្មវិធី',
         },
      ],
   },
   cta: {
      title: 'ត្រៀមរួចរាល់ដើម្បីផ្លាស់ប្តូរអាជីវកម្មរបស់អ្នកហើយឬនៅ?',
      description:
         'ទំនាក់ទំនងមកយើងនៅថ្ងៃនេះ ដើម្បីស្វែងយល់ពីរបៀបដែលដំណោះស្រាយ AKAS អាចជួយឱ្យស្ថាប័នរបស់អ្នករីកចម្រើន។',
      button: 'ទំនាក់ទំនងមកយើង',
   },
};
